<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" @click="handleWeekDishes(1)">上一周</a-button>
      <a-button type="primary" @click="handleWeekDishes(2)">下一周</a-button>
    </div>

    <a-table
      ref="table"
      size="default"
      rowKey="date"
      :columns="columns"
      :dataSource="list"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="false"
      :loading="loading"
    >
      <div slot="week" slot-scope="text, record">
        <span style="font-weight: bold; font-size: medium">{{ record.week }}</span>
        <br/>
        <span style="color: #999">{{ record.date }}</span>
      </div>
      <div slot="breakfast" slot-scope="text, record" v-html="record.breakfastFormat"></div>
      <div slot="lunch" slot-scope="text, record" v-html="record.lunchFormat"></div>
      <div slot="dinner" slot-scope="text, record" v-html="record.dinnerFormat"></div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleShowPeople(record)"><a-icon type="user-add"/></a>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)"><a-icon type="edit"/></a>
        </template>
      </span>
    </a-table>
    <create-form ref="createModal" :info="info" @ok="handleOk"/>
    <show-users ref="showUsers" @ok="handleOk"/>
  </a-card>
</template>

<script>
import CreateForm from './modules/CreateForm'
import ShowUsers from './modules/ShowUsers'
import { getDishesList } from '@/api/manage'

export default {
  name: 'Index',
  components: {
    CreateForm,
    ShowUsers
  },
  data () {
    return {
      loading: false,
      // 查询参数
      queryParam: {
        week: 0,
        role: '/admin/dishes/index'
      },
      // 表头
      columns: [
        {
          title: '日期',
          width: '100px',
          dataIndex: 'week',
          scopedSlots: { customRender: 'week' }
        },
        {
          title: '早餐',
          width: '200px',
          dataIndex: 'breakfastFormat',
          scopedSlots: { customRender: 'breakfast' }
        },
        {
          title: '午餐',
          width: '200px',
          dataIndex: 'lunchFormat',
          scopedSlots: { customRender: 'lunch' }
        },
        {
          title: '晚餐',
          width: '200px',
          dataIndex: 'dinnerFormat',
          scopedSlots: { customRender: 'dinner' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true,
      currentWeek: 0,
      info: {}
    }
  },
  filters: {},
  created () {
    this.tableOption()
    this.handleInitList()
  },
  methods: {
    handleInitList () {
      this.loading = true
      return getDishesList(this.queryParam)
        .then(res => {
          res.result.forEach((val) => {
            val.breakfastFormat = val.breakfast ? val.breakfast.replace(/(\r\n|\n|\r)/gm, '<br />') : ''
            val.lunchFormat = val.lunch ? val.lunch.replace(/(\r\n|\n|\r)/gm, '<br />') : ''
            val.dinnerFormat = val.dinner ? val.dinner.replace(/(\r\n|\n|\r)/gm, '<br />') : ''
          })
          this.list = res.result
        })
        .finally(() => {
          this.loading = false
        })
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit (record) {
      this.info = record
      this.$refs.createModal.show()
    },
    handleOk () {
      this.handleInitList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleWeekDishes (type) {
      if (type === 1) {
        this.queryParam.week--
      } else {
        this.queryParam.week++
      }
      this.handleInitList()
    },
    handleShowPeople (record) {
      if (record.id === '') {
        this.$message.warning('请先完善菜单')
        return false
      }
      this.$refs.showUsers.show(record)
    }
  }
}
</script>
